import { refreshToken, http as axios } from "./axios";
import jwt_decode from "jwt-decode";

import { clearAuthTokens, getAccessToken, setAuthTokens } from "axios-jwt";

class AuthService {
  async login(user) {
    const response = await axios.post("auth", {
      username: user.username,
      password: user.password,
    });

    if (response.data.access_token) {
      setAuthTokens({
        accessToken: response.data.access_token,
        refreshToken: response.data.refresh_token,
      });
    } else {
      throw new Error("invalid server response");
    }
    return this.profile();
  }

  logout() {
    clearAuthTokens();
    localStorage.removeItem("user");
  }

  register(user) {
    delete user["false"];
    delete user["true"];
    delete user["survey"];

    return axios.post("auth/register", user);
  }

  requestOnetimeCode(user) {
    return axios.post("auth/request_onetimecode", user);
  }

  async profile() {
    const profile = await axios.get("auth/me");

    if (profile.data) {
      localStorage.setItem("user", JSON.stringify(profile.data.me));
    } else {
      throw new Error("invalid server response");
    }

    return profile.data.me;
  }

  updatePassword(user) {
    return axios.put("auth/change_password", {
      current: user.current,
      new: user.new,
      new_confirm: user.new_confirm,
    });
  }

  forgotPassword(email) {
    return axios.post("auth/forgot_password", {
      email,
    });
  }

  resetPassword(user) {
    return axios.put("auth/change_forgotten_password", user);
  }

  confirmRegistration(user) {
    return axios.put("auth/register_confirm", user);
  }

  check() {
    return axios.get("auth/verify");
  }

  checkClient() {
    const token = getAccessToken();
    const jwt = jwt_decode(token);

    var current_time = new Date().getTime() / 1000;
    if (current_time > jwt.exp) {
      return Promise.reject("expired");
    }

    return Promise.resolve(true);
  }

  refreshToken(refresh) {
    return refreshToken(refresh);
  }
}

export default new AuthService();
